module.exports = __webpack_public_path__ + "static/img/kf.a8437211.png";